<template>
  <v-container id="home" class="rounded-lg gradient" style="min-height: 700px">
    <!--    <MyCarousel></MyCarousel>-->
    <v-container>
      <v-row no-gutters justify="end">
        <v-col
            cols="12"
            md="3"
        >
          <v-card outlined color="#F1F4F8" class="rounded-lg ma-3">
            <h2 style="text-align: center; color: #333333;" class="my-1">Important Dates</h2>
            <v-timeline
                dense
            >
              <v-timeline-item fill-dot>
                <strong>17 Apr 2022</strong>
                <br>
                <s
                    style="text-line-through: double; font-weight: lighter; font-size: small"
                >31 Mar 2022</s>
                <div class="text-caption">
                  Paper submission
                </div>
              </v-timeline-item>
              <v-timeline-item fill-dot>
                <strong>5 June 2022</strong>
                <br>
                <s
                    style="text-line-through: double; font-weight: lighter; font-size: small"
                >31 May 2022</s>
                <div class="text-caption">
                  Notification
                </div>
              </v-timeline-item>
              <v-timeline-item fill-dot>
                <strong>19 July 2022</strong>
                <br>
                <s
                    style="text-line-through: double; font-weight: lighter; font-size: small"
                >5 July 2022</s>
                <div class="text-caption">
                  Camera-Ready
                </div>
              </v-timeline-item>
            </v-timeline>
          </v-card>
        </v-col>

        <v-col
            cols="12"
            md="9"
        >
          <v-card class="ma-3 px-6" elevation="0" style="background: transparent" tile>
            <h1 class="my-3">News</h1>
            <p v-for="item in news" :key="item">
              <span v-html="item"></span>
            </p>
<!--            <p style="border-left: 9px solid #f24300aa">-->
<!--              <span style="font-weight: bolder; color: #f24300aa; font-style: oblique">NEW</span>-->
<!--              Registration is now open! Please visit the <a href="/#/registration">registration</a> page for details.-->
<!--            </p>-->
          </v-card>

          <v-card class="ma-3 px-6" height="100%" elevation="0" style="background: transparent">
            <br>
            <h2 style="color: #606060">Past Events</h2>
            <v-divider></v-divider>
            <br>
            <v-row class="mx-2">
              <span
                  v-for="x in [2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2011]"
                  :key="x"
              >
                <a :href="`http://www.wocc.org/wocc${x}`" target="_blank">{{ x }}</a>
                &emsp;
              </span>
            </v-row>
            <v-row class="mx-2">
              <span
                  v-for="x in [2009, 2008, 2007, 2006, 2005, 2004, 2003, 2002, 2001]"
                  :key="x"
              >
                <a :href="`http://www.wocc.org/wocc${x}`" arget="_blank">{{ x }}</a>
                &emsp;
              </span>
            </v-row>

          </v-card>
        </v-col>
      </v-row>
    </v-container>

  </v-container>
</template>

<script>


//import axios from "axios";

export default {
  name: "Home",
  // components: {MyCarousel},
  data: () => ({
    // eslint-disable-next-line no-undef
    news: news
  }),
  // created() {
  //   axios.request({
  //     url: '/news.json',//直接填写json文件在public下的路径即可
  //     method: 'get',
  //     headers: {
  //       'Cache-Control': 'no-cache'
  //     }
  //   }).then(res => {
  //     console.log(res.data)
  //     this.news = res.data.news
  //   })
  // }
}
</script>

<style scoped>
#home {
  background-color: #ffffff;
  font-family: SourceHanSansCN-Regular, system-ui;
}

p {
  font-family: SourceHanSansCN-Regular;
  font-size: 17px;
  color: #444444;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 400;
  border-left: 5px solid #0d47a1;
  padding-left: 10px;
}

a {
  text-decoration: none
}

</style>
